var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSupport = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.078 12.943c0-.548.447-.996.995-.996h7.96c.548 0 .996.448.996.996a.998.998 0 0 1-.995.995H7.073a.998.998 0 0 1-.995-.995Zm0-3.983c0-.547.447-.995.995-.995h2.985c.547 0 .995.448.995.995a.998.998 0 0 1-.995.996H7.073a.998.998 0 0 1-.995-.996ZM.107 10.952C.107 4.898 5.013 0 11.053 0S22 4.898 22 10.952c0 6.053-4.896 10.951-10.947 10.951-1.91 0-3.702-.488-5.274-1.354l-2.995 1.285c-1.652.707-3.324-.966-2.618-2.619l1.284-2.997a10.926 10.926 0 0 1-1.343-5.266Zm10.946-8.96c-4.946 0-8.956 4.011-8.956 8.96A8.79 8.79 0 0 0 3.42 15.63l.27.438-1.683 3.933 3.931-1.683.438.269a8.923 8.923 0 0 0 4.677 1.324c4.946 0 8.957-4.012 8.957-8.96 0-4.949-4.01-8.96-8.957-8.96Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSupport);
export default ForwardRef;